"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPlaceholderStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _formInputTheme = require("../../../textinput/styled/formInputTheme");
var _typography = require("../../../typography");
var _selectV2Theme = require("../selectV2Theme");
const SelectPlaceholderStyled = (0, _styled.default)(_typography.TypeRampV2)`
    color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _formInputTheme.formInputTheme.placeholderColor.hover(themeMode);
}};

    position: absolute;
    top: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _formInputTheme.formInputTheme.placeholderTop(themeMode);
}};
    margin-top: auto;
    margin-bottom: auto;
    left: ${_ref3 => {
  let {
    hasContentBefore,
    themeMode
  } = _ref3;
  return hasContentBefore ? _selectV2Theme.selectV2Theme.input.padding.placeholder(themeMode) : _selectV2Theme.selectV2Theme.input.padding.left(themeMode);
}};

    user-select: none;
    right: 30px;
    text-align: left;
    pointer-events: none;
`;
exports.SelectPlaceholderStyled = SelectPlaceholderStyled;
//# sourceMappingURL=SelectPlaceholderStyled.js.map